import React, { useEffect } from 'react';
import moment from 'moment';
import fetchIntegrationLog from './queries/getIntegrationLogList';
import ApiPagination from '../common/ApiPagination';

const columns = ['PO number', 'Status ', 'updated at (IST) ', 'updated by '];
const paginationRowList = [10, 20, 30, 40, 50];

const TransactionLogs = ({ search, pageNumber, setpageNumber, rowsCount, setrowsCount }) => {
  useEffect(() => {
    if (search?.length > 2) {
      setpageNumber(1);
    }
  }, [search]);
  const dataone = {
    Page: pageNumber,
    PageSize: rowsCount,
    poNumber: search.length > 2 ? search : ''
  };

  const { isLoading, error, data, isError } = fetchIntegrationLog(dataone);
  const { items, totalItems, totalPages } = data?.data || {};

  if (isError) {
    return <>{error.message}</>;
  }

  const handleRowsCount = (value) => {
    setpageNumber(1);
    setrowsCount(value);
  };

  return (
    <>
      <div className="manning-table-log muli ">
        <div className="table-row table-head bg-primary-50 grid-col-4-min">
          {columns.map((item) => (
            <div className="table-cell capitalize">{item}</div>
          ))}
          <div className="table-cell" />
        </div>
        <div className="table-body custom-scroll">
          {isLoading ? (
            <h1>Loading...</h1>
          ) : (
            <>
              {items && items.length > 0 ? (
                <>
                  {items?.map((item) => (
                    <div className="table-row grid-col-4-min">
                      <div className="table-cell">
                        <label>{item?.poNumber || 'Invalid PO Number'}</label>
                      </div>
                      <div className="table-cell">
                        <label>{item?.status}</label>
                      </div>
                      <div className="table-cell">
                        <label>{moment(item?.updatedAt).format('DD/MM/YYYY HH:mm:ss')}</label>
                      </div>
                      <div className="table-cell">
                        <label>{item?.updatedBy}</label>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <h1>No Data Available</h1>
              )}
            </>
          )}
        </div>
      </div>
      {!isLoading && (
        <>
          {totalItems > 5 && (
            <ApiPagination
              {...{
                setpageNumber,
                pageNumber,
                totalPages,
                paginationRowList,
                rowsCount,
                handleRowsCount
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default TransactionLogs;
